import { initializeApp, getApp, getApps } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

let firebaseConfig: any = {
  apiKey: "AIzaSyALlAW3l5O1pTXf4erpBamIl-yJlJuyStM",
  authDomain: "okeechobee-dev.firebaseapp.com",
  projectId: "okeechobee-dev",
  storageBucket: "okeechobee-dev.appspot.com",
  messagingSenderId: "574403274840",
  appId: "1:574403274840:web:e8fc5cf157827ae41dc22d",
  measurementId: "G-PSGX9D4Q03",
};

if (process.env.REACT_APP_ENVIRONMENT === "production") {
  firebaseConfig = {
    apiKey: "AIzaSyB-2Sy5rRlTCDG0cKCG7hY0sfzBsieMRCU",
    authDomain: "okeechobee-4911a.firebaseapp.com",
    projectId: "okeechobee-4911a",
    storageBucket: "okeechobee-4911a.appspot.com",
    messagingSenderId: "1045641836054",
    appId: "1:1045641836054:web:177775a034701a5bcd6737",
    measurementId: "G-2QS1VK5FJN",
  };
}

const firebaseApp =
  getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig);

const db = getFirestore();
const storage = getStorage();
const auth = getAuth();
const functions = getFunctions(getApp());

console.log(process.env);

if (process.env.REACT_APP_ENVIRONMENT === "local") {
  connectAuthEmulator(
    auth,
    `http://localhost:${process.env.REACT_APP_EMULATORS_AUTH_PORT}`
  );
  connectFunctionsEmulator(functions, "localhost", 5001);

  connectFirestoreEmulator(db, "localhost", 8070);

  connectStorageEmulator(storage, "localhost", 9199);
}

export { db, storage, functions, auth };
